'use client';

import { useState } from 'react';

export default function ExpandableBio({ text }: { text: string }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <p
      onClick={() => setExpanded((prev) => !prev)}
      className={`cursor-pointer font-inter text-sm font-bold leading-[1.4] text-[#002726] ${
        expanded ? '' : 'line-clamp-2'
      }`}
    >
      {text}
    </p>
  );
}
